import { HTMLCustomElement } from "@theme/html-custom-element";
import { Swiper } from "@theme/swiper";

class CartDrawerPromo extends HTMLCustomElement {
  /** @type {import("swiper").Swiper | undefined} */
  swiper;

  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (!this.refs.swiper) return;

    const slides = this.refs.swiper.querySelectorAll(".swiper-slide");
    if (slides.length === 0) return;

    this.swiper = new Swiper(this.refs.swiper, {
      slidesPerView: "auto",
      spaceBetween: 16,
      freeMode: {
        enabled: true,
      },
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = undefined;
    super.disconnectedCallback();
  }
}

if (!customElements.get("cart-drawer-promo")) {
  customElements.define("cart-drawer-promo", CartDrawerPromo);
}
